<new-flowbanner [showPromo]="true"></new-flowbanner>

<section class="payment-rejected" data-testid="rejected-state">
  <div class="payment-rejected__hero">
    <img
      src="./assets/img/Pago_rechazado.png"
      width="258" height="258" loading="lazy"
      alt="Ilustración de pago rechazado." />
  </div>

  <h1 class="payment-rejected__title">Tu pago ha sido rechazado</h1>

  <div class="payment-rejected__subtitle-container">
    <p class="payment-rejected__subtitle">
      <ng-container *ngIf="valorAPagar() > 0; else genericMessage">
        Tu pago por ${{ valorAPagar() | number: '1.0-0' }} no se ha completado. Por favor, verifica tus datos de pago e inténtalo nuevamente.
      </ng-container>
      <ng-template #genericMessage>
        No pudimos procesar tu pago. Por favor verifica tus datos e inténtalo nuevamente.
      </ng-template>
    </p>
  </div>

  <button
    type="button"
    class="btn btn-primary btn-lg rounded-pill payment-rejected__back"
    data-testid="payment-rejected-back"
    (click)="intentarDeNuevo()"
  >
    Intentar de nuevo
  </button>
</section>

<app-footer-app></app-footer-app>
